"use strict";
/**
* bond_const.ts
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Tool     : bondc, Version=3.0.1, Build=bond-git.debug.not
//     Template : Microsoft.Bond.Rules.dll#TypeScript.tt
//     File     : bond_const.ts
//
//     Changes to this file may cause incorrect behavior and will be lost when
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
var _BondDataType;
(function (_BondDataType) {
    _BondDataType[_BondDataType["_BT_STOP"] = 0] = "_BT_STOP";
    _BondDataType[_BondDataType["_BT_STOP_BASE"] = 1] = "_BT_STOP_BASE";
    _BondDataType[_BondDataType["_BT_BOOL"] = 2] = "_BT_BOOL";
    _BondDataType[_BondDataType["_BT_DOUBLE"] = 8] = "_BT_DOUBLE";
    _BondDataType[_BondDataType["_BT_STRING"] = 9] = "_BT_STRING";
    _BondDataType[_BondDataType["_BT_STRUCT"] = 10] = "_BT_STRUCT";
    _BondDataType[_BondDataType["_BT_LIST"] = 11] = "_BT_LIST";
    _BondDataType[_BondDataType["_BT_MAP"] = 13] = "_BT_MAP";
    _BondDataType[_BondDataType["_BT_INT32"] = 16] = "_BT_INT32";
    _BondDataType[_BondDataType["_BT_INT64"] = 17] = "_BT_INT64";
})(_BondDataType = exports._BondDataType || (exports._BondDataType = {}));
